import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { DYNAMIC_PRICING_CATEGORY_LABEL } from 'common/constants'
import DynamicPricingIcon from 'common/views/components/DynamicPricingIcon/DynamicPricingIcon'

const IconWrapper = styled.div`
  height: 24px;
  width: 24px;
  margin: 0 6px 0 0;
`

const TextWrapper = styled.div`
  font-size: 14px;
  line-height: 23px;
  font-family: "Circular", sans-serif;
  font-weight: 500;
  color: #1C1C1C;
`

const BadgeBase = ({ type, className, onClick }) => (
  <div className={className} onClick={onClick}>
    <IconWrapper>
      <DynamicPricingIcon type={type} />
    </IconWrapper>
    <TextWrapper>
      {DYNAMIC_PRICING_CATEGORY_LABEL[type] || ''}
    </TextWrapper>
  </div>
)

export const StyledBadge = styled(BadgeBase)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 7px 0;
  position: relative;

  ${({ onClick }) => typeof onClick === 'function' ? 'cursor: pointer;' : ''}

  :first-child {
    margin-top: 0;
  }
`

export const LeadTypeBadges = ({ leadTags }) => (
  <div>
    {leadTags.map(({ type }) => {
      return <StyledBadge key={type} type={type} />
    })}
  </div>
)

export default connect(null, {  })(LeadTypeBadges)
